import { type AxiosRequestConfig } from 'axios'

const checkNotification = (id: string): AxiosRequestConfig => {
  return {
    method: 'Put',
    url: '/notifications/item',
    params: {
      id
    }
  }
}

export { checkNotification }
